// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b5b43f0b","115":"2b0664f9","154":"a56a942f","382":"c1e6aa8b","402":"7496b09a","703":"76dfe91c","925":"477144e9","979":"cc2890d9"}[chunkId] + ".chunk.js";
};